module.exports = __webpack_public_path__ + "static/img/codeBg.f0c2d71.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/codeTraceability/codeBg.png
// module id = lqGf
// module chunks = 2